export default defineNuxtRouteMiddleware((to) => {
  const cookieOpts = { maxAge: 60 * 60 * 24 * 30, path: '/' }

  const sourceCookie = useCookie('utm_source', cookieOpts)
  const mediumCookie = useCookie('utm_medium', cookieOpts)
  const campaignCookie = useCookie('utm_campaign', cookieOpts)

  // 1. Captura básica de Query Params
  const { utm_source, utm_medium, utm_campaign, aff } = to.query

  if (utm_medium) mediumCookie.value = utm_medium as string
  if (utm_campaign) campaignCookie.value = utm_campaign as string

  // 2. Lógica de Atribuição de Source (Hierárquica)
  if (utm_source) {
    // Prioridade 1: UTM Manual
    sourceCookie.value = utm_source as string
  } else {
    // Prioridade 2: Auto-tagging de Mídia Paga (IDs de clique)
    const clickIdentifiers = {
      gclid: { s: 'google', m: 'cpc', c: 'adwords' },
      gclsrc: { s: 'google', m: 'cpc', c: 'doubleclick' },
      fbclid: { s: 'facebook', m: 'cpc', c: 'meta_ads' }, // Pode ser Insta ou FB Ads
      ttclid: { s: 'tiktok', m: 'cpc', c: 'tiktok_ads' },
      li_fat_id: { s: 'linkedin', m: 'cpc', c: 'linkedin_ads' },
      msclkid: { s: 'bing', m: 'cpc', c: 'bing_ads' }
    }

    let foundClickId = false
    for (const [param, config] of Object.entries(clickIdentifiers)) {
      if (to.query[param]) {
        sourceCookie.value = config.s
        mediumCookie.value = config.m
        campaignCookie.value = config.c
        foundClickId = true
        break
      }
    }

    // Prioridade 3: Referrer (Orgânico/Social) - Apenas se não achou ID de clique
    if (!foundClickId && import.meta.client) {
      const referrer = document.referrer
      if (referrer) {
        try {
          const host = new URL(referrer).hostname.toLowerCase()
          const isInternal = host.includes('seurole.com.br')

          if (!isInternal) {
            // Mapeamento detalhado de Social Orgânico
            if (host.includes('facebook')) {
              sourceCookie.value = 'facebook'
              mediumCookie.value = 'social'
            } else if (host.includes('instagram')) {
              sourceCookie.value = 'instagram'
              mediumCookie.value = 'social'
            } else if (host.includes('linkedin')) {
              sourceCookie.value = 'linkedin'
              mediumCookie.value = 'social'
            } else if (host.includes('tiktok')) {
              sourceCookie.value = 'tiktok'
              mediumCookie.value = 'social'
            } else if (host.includes('t.co') || host.includes('twitter') || host.includes('x.com')) {
              sourceCookie.value = 'twitter'
              mediumCookie.value = 'social'
            } else if (host.includes('youtube')) {
              sourceCookie.value = 'youtube'
              mediumCookie.value = 'social'
            } else {
              sourceCookie.value = host.replace('www.', '')
              mediumCookie.value = 'referral'
            }
            campaignCookie.value = '(not set)'
          }
        } catch (e) { /* referrer inválido */ }
      }
    }

    // Prioridade 4: Fallback Direto
    if (!sourceCookie.value) {
      sourceCookie.value = '(direct)'
      mediumCookie.value = '(none)'
      campaignCookie.value = '(direct)'
    }
  }
})
